import { render, staticRenderFns } from "./message-board.vue?vue&type=template&id=1ba32f38&"
import script from "./message-board.vue?vue&type=script&lang=js&"
export * from "./message-board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports